import React from 'react';

import X from 'assets/svg/close.svg';

import s from './CloseButton.scss';
import { useIntl } from 'react-intl';

interface IProps {
  children?: React.ReactNode;
  onClick?: (e: React.SyntheticEvent) => void;
}

export const CloseButton = ({ children, onClick }: IProps) => {
  const intl = useIntl();

  return (
    <button className={s.closeButton} onClick={onClick}>
      {children ?? intl.formatMessage({ id: 'close', defaultMessage: 'Loka' })}
      <X className={s.closeButton__icon} />
    </button>
  );
};
